<template>
<div class="sort">
  <div class="count-product-list"></div>
    <div class="sort-select" v-click-outside="hide">
        <span class="sort-select__current" :class="{'current' : showSorting}" @click="showSortingFn">{{ nameCurrent }}
          <span class="o-ico o-ico--arrow-down o-ico--s">
            <svg> <use xlink:href="#ico-down-open" aria-hidden="true"></use> </svg>
          </span>
      </span>
        <ul class="sort-select__list" v-if="showSorting">
          <li @click="selectSort('Popularne')" :class="{'current': nameCurrent === 'Popularne'}">Popularne</li>
          <li @click="selectSort('Najlepiej ocenione')" :class="{'current': nameCurrent === 'Najlepiej ocenione'}">Najlepiej ocenione</li>
          <li @click="selectSort('Nowości')" :class="{'current': nameCurrent === 'Nowości'}">Nowości</li>
          <li @click="selectSort('Promocje')" :class="{'current': nameCurrent === 'Promocje'}">Promocje</li>
          <li @click="selectSort('Cena: od najwyższej')" :class="{'current': nameCurrent === 'Cena: od najwyższej'}">Cena: od najwyższej</li>
          <li @click="selectSort('Cena: od najniższej')" :class="{'current': nameCurrent === 'Cena: od najniższej'}">Cena: od najniższej</li>
        </ul>
    </div>
</div>
</template>
<script>
import getUrlParameter from '@/shared/geturlparamter'
export default {
  name: 'SearchSorting',
  data: function () {
    return {
      nameCurrent: 'Popularne',
      showSorting: false
    }
  },
  methods: {
    showSortingFn () {
      this.showSorting = !this.showSorting
    },
    hide () {
      this.showSorting = false
    },
    selectSort (name) {
      this.showSorting = !this.showSorting
      this.nameCurrent = name
      this.$emit('changeSort', name)
    }
  },
  mounted: function () {
    const sort = getUrlParameter('orderway')
    const sortBy = getUrlParameter('orderby')
    if (sort === 'asc' && sortBy === 'price') {
      this.nameCurrent = 'Cena: od najniższej'
    } else if (sort === 'desc' && sortBy === 'price') {
      this.nameCurrent = 'Cena: od najwyższej'
    } else if (sortBy === 'promo') {
      this.nameCurrent = 'Promocje'
    } else if (sortBy === 'new') {
      this.nameCurrent = 'Nowości'
    } else if (sortBy === 'rate') {
      this.nameCurrent = 'Najlepiej ocenione'
    } else {
      this.nameCurrent = 'Popularne'
    }
  },
  directives: {
    'click-outside': {
      bind: function (el, binding, vNode) {
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) { warn += `Found in component '${compName}'` }
          // eslint-disable-next-line
          console.warn(warn)
        }
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler

        document.addEventListener('click', handler)
      },

      unbind: function (el) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.sort {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 15px;
  @media all and (min-width: 1024px) {
    position: absolute;
    right: 0;
    top: 4px;
  }
  @media all and (min-width: 768px) {
    .count-product-list {
      display: none;
    }
  }
  .sort-select {
    margin: 0 0 0 5px;
    min-width: 130px;
    position: relative;
    @media all and (max-width: 767px) {
      width: 100%;
      margin: 18px 0 0 0;
      display: none;
      &.open {
        display: block;
      }
    }
    &__current {
      min-width: 40px;
      position: relative;
      border: 1px solid #A1A1A1;
      font-size: 12px;
      border-radius: 4px;
      height: 27px;
      text-decoration: none;
      text-align: left;
      outline: 0;
      vertical-align: middle;
      background: #fff;
      display: inline-block;
      cursor: default;
      width: 100%;
      padding: 4px 36px 4px 12px;
      cursor: pointer;
      // &:hover {
      //   color: #8AB82D;
      // }
      .o-ico {
        position: absolute;
        right: 13px;
        top: 7px;
        width: 13px;
        height: 11px;
      }
      &.current {
        background: #FFF;
        z-index: 11;
        border-radius: 4px 4px 0 0;
        border-bottom-color: #FFF;
      }
    }
    &__list {
      position: absolute;
      z-index: 10;
      min-width: 100%;
      max-height: 200px;
      min-height: 1em;
      border: solid 1px #cecece;
      background: #ffffff;
      border: 1px solid #A1A1A1;
      overflow: auto;
      top: calc(100% - 2px);
      border-radius: 0 0 4px 4px;
      li {
        list-style: none;
        display: block;
        padding: 0;
        margin: 0;
        line-height: 2em;
        padding: 0 .5em;
        white-space: nowrap;
        overflow: hidden;
        background: 6px center no-repeat;
        cursor: pointer;
        &.current,
        &:hover {
          background: #f0f0f0;
          color: #8AB82D;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Algolia/components/search-sorting.vue